export default "__VITE_ASSET__NTLYu0KD__"